function getApiBaseUrl(): string {
  const { protocol, hostname, port } = window.location;
  const isStandardPort =
    (protocol === 'http:' && port === '80') ||
    (protocol === 'https:' && port === '443') ||
    port === '';

  const base = `${protocol}//${hostname}${isStandardPort ? '' : `:${port}`}`;
  return `${base}/api`;
}

const BASE_URL: string = getApiBaseUrl();
const MUI_X_LICENSE_KEY: string = process.env['MUI_X_LICENSE_KEY'] as string;

const IS_LOCAL: string = process.env['IS_LOCAL'] === 'true' ? 'true' : 'false';

export { BASE_URL, MUI_X_LICENSE_KEY, IS_LOCAL };
